import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="imageblob" id="imageblob"></a>
    <h1 {...{
      "id": "windowimageblob"
    }}>{`window.ImageBlob`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`: UXP v7.0.0  `}</p>
    <a name="new-imageblob-new" id="new-imageblob-new"></a>
    <h2 {...{
      "id": "imageblobarraybuffer-options"
    }}>{`ImageBlob(arrayBuffer, options)`}</h2>
    <p>{`Blobs are used to create URLs, which can be used as `}<inlineCode parentName="p">{`src`}</inlineCode>{` in `}<inlineCode parentName="p">{`HTMLImageElement`}</inlineCode>{`. It can be created using image data in the standard compression formats such as PNG, JPG, JPEG ,etc.
ImageBlob is a custom type that extends the support to use uncompressed image data. `}<br></br>{`
e.g. ImageBlob can be created by passing arrayBuffer containing the RGB values for each pixel and options containing metadata to interpret the data in arraybuffer.`}</p>
    <p>{`ImageBlob can be created in the following ways`}</p>
    <ul>
      <li parentName="ul">{`standard image compression formats: pass ArrayBuffer of the `}<inlineCode parentName="li">{`standard compression formats`}</inlineCode>{` and mimeType of the compression in the options.type.`}</li>
      <li parentName="ul">{`uncompressed image: pass ArrayBuffer of the uncompressed image data i.e. raw data of each pixel and options to interpret the data, option.type should be passed as "image/uncompressed".`}<br></br></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/2022/ps_reference/media/imaging/#photoshopimagedata-1"
      }}>{`PhotoshopImageData`}</a>{` is compatible with ImageBlob,
`}<inlineCode parentName="p">{`PhotoshopImageData`}</inlineCode>{` object can be directly passed in for options.`}</p>
    <b>Note: `ImageBlob support is subject to enablement by HostApp. Currently supported by Photoshop.`</b>
    <p><strong parentName="p">{`Returns`}</strong>{`: Instance of `}<inlineCode parentName="p">{`ImageBlob`}</inlineCode>{` with the given data`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the arrayBuffer is not of type ArrayBuffer`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` thrown if the height or width is not provided or if either is < 0`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` thrown if the colorSpace mentioned is not supported`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` thrown if the componentSize mentioned is not supported`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` thrown if the ByteLength of not matching the required size as per the given options`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` thrown if the PixelFormat mentioned is not supported`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayBuffer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ArrayBuffer`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ArrayBuffer containing the image data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Meta data to interpret ArrayBuffer passed. For standard compression options.type is mandatory, for uncompressed image data all the values are mandatory unless mentioned optional`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`mimeType of the imageData passed. Could be standard formats "image/png", "image/jpg" and for uncompressed data "image/uncompressed"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The width in pixels of the image data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.height`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The height in pixels of the image data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.colorSpace`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The color space (or mode) for the image data. This can be "RGB" or "Grayscale"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.hasAlpha`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if the image includes an alpha channel`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.components`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number of components per pixel. This is 3 for RGB, 4 for RGBA and so forth`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.componentSize`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number of bits per component. This can be 8 or 16`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.pixelFormat`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Memory layout (order) of components in a pixel. Could be "RGB", "RGBA", or "Gray"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.colorProfile`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`[Optional]`}</inlineCode>{` - The color profile (or mode) for the image data. This could be be "Adobe RGB (1998)"`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Updating HTML with ImageBlob
<!DOCTYPE html>
<html>

<head>
<script src="index.js"></script>
</head>
<style>
body {
  background-color: whitesmoke;
  padding: 0 16px;
}

#image,

container {
   margin: 8px;
   display: flex;
   flex-direction: row;
   justify-content: flex-start
}
</style>

 <body>
<div class="container">
   <sp-button id="pixel-btn" variant="secondary" quiet>Paint image</sp-button>
   <img id="image"></img>
</div>

</body>
</html>

//Creating ImageBlob by creating the options Object seperatly and then pass the Object as argument
function getPixel() {
 const imageMetaData = {
    width : 8,
    height : 8,
    colorSpace : "RGB",
    colorProfile : "",
    pixelFormat : "RGB",
    components : 3,
    componentSize : 8,
    hasAlpha : false, // Alpha is set to false
    type : "image/uncompressed",
 }

 let buffer = new ArrayBuffer(imageMetaData.width * imageMetaData.height * 3);
 let colorArrayView = new Uint8Array(buffer);
 for(let i = 0; i < colorArrayView.length / 4; i++) {
    // here we are creating a red image, update values to see the variations
    colorArrayView[i * 3] = 255; // Red Component
    colorArrayView[i * 3 + 1] = 0; // Green Component
    colorArrayView[i * 3 + 2] = 0; // Blue Component
 }
 let imageBlob = new ImageBlob(colorArrayView, imageMetaData);
 // Generate url which can be used as src on HTMLImageElement
 const url = URL.createObjectURL(imageBlob);
 // ensure that there is a HTMLImageElement in the Document with id \`image\`.
 const imageElement = document.getElementById("image");
 imageElement.src = url;

 // revoke(destroy image from the memory) when url is no more required.
 URL.revokeObjectURL(url);
}
document.addEventListener("DOMContentLoaded", () => {
document.getElementById("pixel-btn").addEventListener("click", getPixel);
});
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Creating ImageBlob using PhotoshopImageData object(more details about PhotoshopImageData in description).
const photoshopImageObject; // get image object using Photoshp's imaging apis.
let colorArrayView = await photoshopImageObject.getData();

let imageBlob = new ImageBlob(colorArrayView, photoshopImageObject);
// Generate url which can be used as src on HTMLImageElement
const url = URL.createObjectURL(imageBlob);
// ensure that there is a HTMLImageElement in the Document with id \`image\`.
const imageElement = document.getElementById("image");
imageElement.src = url;

// revoke(destroy image from the memory) when url is no more required.
URL.revokeObjectURL(url);
`}</code></pre>
    <a name="blob-size" id="blob-size"></a>
    <h2 {...{
      "id": "size--number"
    }}>{`size : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Size of the Blob in bytes.`}</p>
    <a name="blob-type" id="blob-type"></a>
    <h2 {...{
      "id": "type--string"
    }}>{`type : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
MIME type of the Blob.`}</p>
    <a name="blob-arraybuffer" id="blob-arraybuffer"></a>
    <h2 {...{
      "id": "arraybuffer"
    }}>{`arrayBuffer()`}</h2>
    <p>{`Get the contents of the Blob in the form of an ArrayBuffer.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<ArrayBuffer>`}</inlineCode>{` Promise that resolves with an ArrayBuffer that contains the blob's data in binary form.  `}</p>
    <a name="blob-slice" id="blob-slice"></a>
    <h2 {...{
      "id": "slicestart-end-contenttype"
    }}>{`slice(`}{`[start]`}{`, `}{`[end]`}{`, `}{`[contentType]`}{`)`}</h2>
    <p>{`Get a portion of the Blob's data selected from start to end (end not included).`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Blob`}</inlineCode>{` - New Blob object containing the specified subset of the data contained with the blob on which this method was called.
The original blob is not altered.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[start]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`(Optional)`}</inlineCode>{` Index into the Blob indicating the first byte to include in the new Blob`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[end]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`size`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`(Optional)`}</inlineCode>{` Index into the Blob indicating the first byte that will NOT be included in the new Blob`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[contentType]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;\\&quot;\\&quot;&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`(Optional)`}</inlineCode>{` String containing the file's `}<a parentName="td" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Glossary/MIME_type"
            }}>{`MIME type`}</a>{`, or empty string if the type could not be determined. Refer `}<a parentName="td" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Web/API/Blob/type#value"
            }}>{`Blob.type`}</a></td>
        </tr>
      </tbody>
    </table>
    <a name="blob-stream" id="blob-stream"></a>
    <h2 {...{
      "id": "stream"
    }}>{`stream()`}</h2>
    <p>{`Get the data contained within the Blob as a ReadableStream.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`ReadableStream`}</inlineCode>{` - Content of the Blob.  `}</p>
    <a name="blob-text" id="blob-text"></a>
    <h2 {...{
      "id": "text"
    }}>{`text()`}</h2>
    <p>{`Get contents of the Blob as a string.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<string>`}</inlineCode>{` Promise that resolves with a string which contains the blob's data as a text string.
The data is always presumed to be in UTF-8 format.  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      